import { makeAutoObservable } from 'mobx'
import { type ISmartCallFlowCallEndsStep } from 'entities/SmartCall/api/types'
import { FlowActionStore, generateFlowActionId } from 'widgets/Flow'
import { type ISmartCallActionStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'

export type IAddButtonStoreProps = {
  id?: string
  parentId: string
}

export class AddButtonStore {
  static readonly type = 'addButton' satisfies ISmartCallFlowActionType
  public readonly actionStore: ISmartCallActionStore

  constructor({ id, parentId }: IAddButtonStoreProps) {
    this.actionStore = new FlowActionStore({
      parentId,
      id: id ?? generateFlowActionId('addButton'),
      type: AddButtonStore.type,
      name: 'Add action',
      defaultWidth: 20,
      defaultHeight: 20,
      allowedNextActions: ['sendMessage', 'aiTextingAgent'],
    })
    makeAutoObservable(this)
  }

  get step(): ISmartCallFlowCallEndsStep {
    return { id: 'success', type: 'result' }
  }
}
